import { Box, Button, Card, Checkbox, FormControl, FormControlLabel, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Select, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import 'react-quill/dist/quill.snow.css';

import ADD_FILE from '../../assets/images/add_file.svg';
import useProductFormController from "./controller/form";

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import ErrorMessageComponent from "../../components/errorMessage";

import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ReactPlayer from 'react-player/youtube'
import { isYouTubeUrl } from "../../utils/isYoutubeUrl";
import { EN_ACCEPT_LANGUAGE } from "../../constants/acceptLanguageApi";
import { BrandModel } from "../../models/brand";
import ConfirmDialog from "../../components/ConfirmDialog";
import SwitchComponent from "../../components/switch";
import { MasterProductModel } from "../../models/masterProduct";
interface Props {
    onClose: VoidFunction,
    selectedData: any,
    dataMasterMainGroup: any;
    dataMasterDivisions: any;
    dataMasterCategories: any;
    dataMasterSubCategories: any,
    dataBrand: BrandModel[],
    onRefetchData: any
    setData: any
}

const FormComponent = ({ onClose, selectedData, dataBrand, onRefetchData, setData }: Props) => {
    const { t, i18n } = useTranslation("global");

    const controller = useProductFormController({
        selectedData,
        onClose,
        onRefetchData,
        setData
    });



    return <>


        <form onSubmit={controller.handleSubmit} style={{ display: controller.loading ? 'none' : 'block' }}>
            <IconButton onClick={onClose} sx={{ mb: 2 }}>
                <KeyboardBackspaceIcon />
            </IconButton>
            <Typography variant="h5">{t("masterProduct_page.Edit Product")}</Typography>
            <Grid sx={{ mt: 2, pl: 2 }} container spacing={2}>
                <Grid xs={12} sm={9}>
                    <Card sx={{ p: 2, mt: 2 }}>
                        <Typography>{t("masterProduct_page.Item Code")}</Typography>
                        <TextField inputProps={{
                            style: {
                                color: 'grey',
                                fontWeight: 'bold'
                            }
                        }} InputProps={{
                            readOnly: true,
                        }} inputRef={controller.itemCode} fullWidth placeholder="Enter Item Code" margin="normal" />
                        <Typography>{t("masterProduct_page.Name English")}</Typography>
                        <TextField inputRef={controller.nameEn} fullWidth placeholder={t("Enter product name") || ''} margin="normal" />
                        <Typography>{t("masterProduct_page.Name Lao")}</Typography>
                        <TextField inputRef={controller.nameLa} fullWidth placeholder={t("Enter product name") || ''} margin="normal" />
                        <Typography sx={{ mb: 2, mt: 1 }}>{t("masterProduct_page.Description")}</Typography>
                        {/* <ReactQuill
                        theme="snow"
                        style={{ height: 200 }}
                        // onChange={(value) => setValue('description', value)}
                    /> */}
                        {/* {errors.description && (
                        <Typography color="error">{errors?.description?.message?.toString()}</Typography>
                    )} */}
                        {/* <Box sx={{ height: 60 }} /> */}
                        <TextField

                            fullWidth
                            multiline
                            // InputProps={{
                            //     readOnly: true,
                            // }}
                            rows={6}
                            margin="normal"
                            inputRef={controller.description}
                        />
                        <Typography sx={{ mb: 2 }}>{t("masterProduct_page.Image main")}<span style={{ color: 'red' }}> *</span></Typography>
                        <Box>
                            <label htmlFor="image-input-main">
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 240, backgroundColor: '#F4F6F8', borderRadius: '8px', borderStyle: 'dotted', borderColor: '#919EAB52', cursor: 'pointer', gap: 2 }}>
                                    <img src={controller.imageMainToShow ? controller.imageMainToShow : ADD_FILE} style={{ width: 212, height: 160, objectFit: 'contain' }} alt="" />
                                    <Box>
                                        <Typography fontWeight="bold" fontSize={20}>{t("masterProduct_page.Select files")}</Typography>
                                        <Typography color="grey">{t("masterProduct_page.Drop files here or click browse through you machine")}</Typography>
                                    </Box>
                                </Box>
                            </label>
                            <input accept="image/*" type="file" id="image-input-main" onClick={(e: any) => { e.target.value = "" }} onChange={(e: any) => { controller.onSelectImageMain(e) }} style={{ display: "none" }} />
                        </Box>


                        <Typography sx={{ mb: 2, mt: 2 }}>{t("Image secondary")}</Typography>

                        <Box mt={2}>
                            <Box mt={2} sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                {
                                    controller.imageSecondaryToShow?.map((item: any, index: number) => {
                                        return <Box key={index} sx={{ maxWidth: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

                                            <img src={controller.imageSecondaryToShow[index]} alt="" style={{
                                                width: 100,
                                                height: 100,
                                                cursor: 'pointer',
                                                objectFit: 'contain'
                                            }} />

                                            <Box sx={{ display: 'flex' }}>
                                                <IconButton disableRipple sx={{ marginTop: '5px' }}>
                                                    <label htmlFor={`image-input-secondary-list${index}`}>
                                                        <EditIcon sx={{ cursor: 'pointer' }} />
                                                    </label>
                                                    <input accept="image/*" type="file" id={`image-input-secondary-list${index}`} onClick={(e: any) => { e.target.value = "" }} onChange={(e: any) => {
                                                        controller.onSelectImageSecondary(e, index);
                                                    }} style={{ display: "none" }} />
                                                </IconButton>
                                                <IconButton disableRipple onClick={() => {
                                                    if (window.confirm(t("Do you want to remove image?") || '')) {
                                                        controller.onRemoveSecondaryImage(index);
                                                    }
                                                }}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    })
                                }
                            </Box>

                            <label htmlFor="image-input-secondary">
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 240, backgroundColor: '#F4F6F8', borderRadius: '8px', borderStyle: 'dotted', borderColor: '#919EAB52', cursor: 'pointer', gap: 2 }}>
                                    <img src={ADD_FILE} style={{ width: 212, height: 160, objectFit: 'contain' }} alt="" />
                                    <Box>
                                        <Typography fontWeight="bold" fontSize={20}>{t("masterProduct_page.Select files")}</Typography>
                                        <Typography color="grey">{t("masterProduct_page.Drop files here or click browse through you machine")}</Typography>
                                    </Box>
                                </Box>
                            </label>
                            <input accept="image/*" type="file" id="image-input-secondary" onClick={(e: any) => { e.target.value = "" }} onChange={(e: any) => controller.onSelectImageSecondary(e, controller.imageSecondaryToShow.length)} style={{ display: "none" }} />
                        </Box>
                        <Typography sx={{ mb: 2, mt: 2 }}>{t("masterProduct_page.Video")}</Typography>
                        <Box mt={2}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 240, backgroundColor: '#F4F6F8', borderRadius: '8px', borderStyle: 'dotted', borderColor: '#919EAB52', gap: 2 }}>
                                <img src={ADD_FILE} style={{ width: 212, height: 160, objectFit: 'contain' }} alt="" />
                                <Box>
                                    <Typography fontWeight="bold" fontSize={20}>{t("masterProduct_page.Paste youtube link here")}</Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Typography color="grey" sx={{ width: 170 }}>{t("masterProduct_page.Drop link here")}</Typography>
                                        <TextField value={controller.linkVideo} onChange={(e) => controller.handleChangeVideLink(e.target.value)} variant="standard" fullWidth placeholder="................................................" InputProps={{ disableUnderline: controller.linkVideo ? false : true }} />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ mt: 2, mb: 2, display: 'flex', justifyContent: 'center' }}>
                            {
                                controller.linkVideo
                                    ?
                                    isYouTubeUrl(controller.linkVideo)
                                        ?
                                        <Box sx={{ maxWidth: 500, height: 300, width: '100%' }}>
                                            <ReactPlayer url={controller.linkVideo} width="100%"
                                                height="100%" />
                                        </Box>
                                        :
                                        <ErrorMessageComponent errorMessage="Invalid youtube url" />
                                    :
                                    null
                            }

                        </Box>
                    </Card>
                </Grid>
                <Grid xs={12} sm={3} sx={{ p: 2 }}>
                    <Typography fontWeight="bold" sx={{ mb: 5 }}>{t("masterProduct_page.Product details")}</Typography>
                    {/* <Typography fontWeight="bold">Unit</Typography>
                    <TextField inputProps={{
                        style: {
                            color: 'grey',
                            fontWeight: 'bold'
                        }
                    }} InputProps={{
                        readOnly: true,
                    }} inputRef={controller.quantity} fullWidth placeholder="Quantity" margin="normal" /> */}
                    <Box mt={2}>
                        <Typography fontWeight="bold">{t("masterProduct_page.Barcode")}</Typography>
                        <Box mt={2}>
                            {/* {
                            controller.barcode?.map((item: string, index: number) => {
                                return <Box key={index}>
                                    {
                                        index < controller.barcode.length - 1
                                        &&
                                        <Typography>{index + 1}. <IconButton onClick={() => {
                                            if (window.confirm("ທ່ານຕ້ອງການທີ່ຈະລົບຂໍ້ມຸນ")) {
                                                controller.onBarcodeChange(controller.barcode?.filter((subItem, subIndex) => subIndex !== index));
                                            }
                                        }}><DeleteIcon /></IconButton></Typography>

                                    }
                                    <TextField onChange={(e: any) => {
                                        controller.onBarcodeChange(controller.barcode?.map((subItem, subIndex) => {
                                            if (index === subIndex) {
                                                return e.target.value;
                                            }
                                            else {
                                                return subItem;
                                            }
                                        }));
                                    }} value={item} fullWidth placeholder="ປ້ອນ Barcode" margin="normal" />
                                </Box>
                            })
                        } */}
                            {
                                controller?.barcode?.map((item: string, index: number) => {
                                    return <Box key={item}>
                                        <Typography>{index + 1}.</Typography>
                                        <TextField margin="normal" InputProps={{
                                            readOnly: true,
                                        }} value={controller.barcode[index]} fullWidth />
                                    </Box>
                                })
                            }
                        </Box>
                        {/* <Button sx={{ textTransform: 'none' }} onClick={controller.onAddBarcode}><AddIcon /> Add barcode</Button> */}
                    </Box>
                    <Typography fontWeight="bold">{t("masterProduct_page.UOM Type")}</Typography>
                    <TextField inputProps={{
                        style: {
                            color: 'grey',
                            fontWeight: 'bold'
                        }
                    }} InputProps={{
                        readOnly: true,
                    }} inputRef={controller.uomType} fullWidth placeholder="UOM Type" margin="normal" />
                    <Typography fontWeight="bold">{t("masterProduct_page.Pack Type")}</Typography>
                    <TextField inputProps={{
                        style: {
                            color: 'grey',
                            fontWeight: 'bold'
                        }
                    }} InputProps={{
                        readOnly: true,
                    }} inputRef={controller.packType} fullWidth placeholder="Pack Type" margin="normal" />
                    {/* <Typography fontWeight="bold" sx={{ mb: 2 }}>Brand</Typography>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <Select
                            value={controller.brand}
                            onChange={controller.handleBrandChange}
                        >
                            {
                                dataBrand?.map((item: BrandModel) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.nameEn : item?.nameLa}</MenuItem>)
                            }
                        </Select>
                    </FormControl> */}
                    <Box mt={2}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="main-group-label-id">Main Group</InputLabel>
                            <Select
                                labelId="main-group-label-id"
                                id="main-group-id"
                                value={controller.masterMainGroup}
                                label="Main Group"
                                onChange={controller.handleMasterMainGroupChange}
                            >
                                {
                                    controller.dataMasterMainGroups?.map((item: any) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.main_group_name_en : item?.main_group_name_la}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="division-label-id">Division</InputLabel>
                            <Select
                                labelId="division-label-id"
                                id="division-id"
                                value={controller.masterDivision}
                                label="Division"
                                onChange={controller.handleMasterDivisionChange}

                            >
                                {
                                    controller.dataMasterDivisions?.filter((item: any) => item?.supplies_main_group_name_id === controller.masterMainGroup)?.map((item: any) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.division_name_en : item?.division_name_la}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="category-label-id">Category</InputLabel>
                            <Select
                                labelId="category-label-id"
                                id="category-id"
                                value={controller.masterCategory}
                                label="Category"
                                onChange={controller.handleMasterCategoryChange}
                            >
                                {
                                    controller.dataMasterCategories?.filter((item: any) => item?.supplies_division_name_id === controller.masterDivision)?.map((item: any) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.category_name_en : item?.category_name_la}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="subCategory-label-id">Sub Category</InputLabel>
                            <Select
                                labelId="subCategory-label-id"
                                id="subCategory-id"
                                value={controller.masterSubCategory}
                                label="Sub Category"
                                onChange={controller.handleMasterSubCategoryChange}
                            >
                                {
                                    controller.dataMasterSubCategories?.filter((item: any) => item?.supplies_product_category_id === controller.masterCategory)?.map((item: any) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.sub_category_name_en : item?.sub_category_name_la}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <SwitchComponent value={controller.isActiveProduct} onChange={controller.handleActiveProduct} />
                        <Typography><span style={{ color: 'red' }}>InActive</span> / <span style={{ color: 'green' }}>Active</span></Typography>
                    </Box>

                    <Box>
                        <ErrorMessageComponent errorMessage={controller.errorMessage} />
                    </Box>
                    <Box mt={2}>
                        <Button type="submit" variant="contained" sx={{ textTransform: 'none', width: '100%', height: 48 }}>{t("masterProduct_page.Edit product")}</Button>
                    </Box>

                </Grid>
            </Grid>
            <ConfirmDialog
                open={controller.openConfirmDialog}
                title={`Do you want to update data?`}
                loading={controller.loadingSubmit}
                onCancel={() => controller.handleSetOpenConfirmDialog(false)}
                onConfirm={() => controller.handleConfirmDialog()}
            />

        </form>

        <LinearProgress sx={{ display: controller.loading ? 'block' : 'none' }} />

    </>
}
export default FormComponent;